import { css } from "@emotion/css";
import { mergeProps } from "react-aria";
import {
  DateRangePicker as AriaDateRangePicker,
  DateRangePickerProps,
} from "react-aria-components";

export function _DateRangePicker(props: DateRangePickerProps<any>) {
  const className = css(styles.calendar);

  return <AriaDateRangePicker {...mergeProps(props, { className })} />;
}

const styles = {
  calendar: css({
    display: "flex",
    flexDirection: "column",
    overflowX: "auto",
    // these are required at the top level, using data-open/focus-within at the
    // sub levels causes the styles to flicker when it swaps between states.
    "&[data-focus-within=true], &[data-open=true]": {
      "> div[role=group]": {
        boxShadow: "var(--focus-input)",
      },
    },
    "&[data-open=true]": {
      "div:nth-child(2)": {
        "> div > button": {
          backgroundColor: "var(--background-accent-tofino-strong)",
        },
        "* i[role=img]": {
          color: "var(--text-inverse)",
        },
      },
    },
  }),
};
